/**
 * Translated CMS page bodies.
 *
 * The English copy lives in the CMS (content_pages). For the non-English
 * locales we ship a translated body here and swap it in at render time, so the
 * layout, classes and links stay identical to the English page.
 *
 * English (any variant) always renders the live CMS content.
 */

import { HOME_PAGE_TRANSLATIONS } from './home';
import { ABOUT_PAGE_TRANSLATIONS } from './about';
import { CONTACT_PAGE_TRANSLATIONS } from './contact';
import { ABC_INTRODUCTION_TRANSLATIONS } from './abcIntroduction';
import { PRIVACY_PAGE_TRANSLATIONS } from './privacy';
import { TERMS_PAGE_TRANSLATIONS } from './terms';
import { RETURNS_PAGE_TRANSLATIONS } from './returns';
import { SHIPPING_PAGE_TRANSLATIONS } from './shipping';
import { FAQ_PAGE_TRANSLATIONS } from './faq';

const PAGE_TRANSLATIONS = {
  home: HOME_PAGE_TRANSLATIONS,
  about: ABOUT_PAGE_TRANSLATIONS,
  contact: CONTACT_PAGE_TRANSLATIONS,
  'abc-introduction': ABC_INTRODUCTION_TRANSLATIONS,
  'privacy-policy': PRIVACY_PAGE_TRANSLATIONS,
  'terms-of-use': TERMS_PAGE_TRANSLATIONS,
  'return-policy': RETURNS_PAGE_TRANSLATIONS,
  'shipping-policy': SHIPPING_PAGE_TRANSLATIONS,
  faq: FAQ_PAGE_TRANSLATIONS,
};

/**
 * @param {string} pageId — CMS page id (e.g. "home", "about")
 * @param {string} language — active language code (e.g. "fr-CA")
 * @returns {{title: string, description: string, html: string} | null}
 */
export function getTranslatedPage(pageId, language) {
  if (!pageId || !language || language === 'en' || language.startsWith('en')) return null;
  return PAGE_TRANSLATIONS[pageId]?.[language] || null;
}

export function hasTranslatedPage(pageId, language) {
  return Boolean(getTranslatedPage(pageId, language));
}
